import Icon, { type IconTypes } from '@components/utils/Icon'
import { useCopied } from '@hooks/useCopied'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('components.copiable_value')

export function CopyButton({ value, testId, label }: { value: string; testId: string; label: string }) {
  const [copied, copy] = useCopied()

  return (
    <button
      type="button"
      onClick={() => copy(value)}
      className="tw:inline-flex tw:items-center tw:p-0.5 tw:rounded tw:text-gray-400 tw:hover:text-gray-600 tw:transition-colors"
      aria-label={label}
      data-testid={testId}
    >
      {copied ? (
        <span role="status" className="tw:text-xs tw:text-green-600 tw:font-medium">{t('copied')}</span>
      ) : (
        <Icon type="copy-06" width={14} height={14} />
      )}
    </button>
  )
}

export function CopiableValue({
  icon,
  value,
  copyLabel,
  testId,
}: {
  icon: IconTypes
  value: string
  copyLabel: string
  testId: string
}) {
  return (
    <span className="tw:inline-flex tw:items-center tw:gap-1">
      <Icon type={icon} width={14} height={14} className="tw:text-gray-400" />
      <span data-testid={`contact-${testId}`}>{value}</span>
      <CopyButton value={value} testId={`copy-${testId}-button`} label={copyLabel} />
    </span>
  )
}
